export default __webpack_public_path__ + "static/vierSaeulen-a772500bbb383c620522ef60b782d32b.png";